import { ServiceValues } from '../values/ServiceValues';
import { ServiceAxios } from './ServiceEW';
import { Values } from '../values/Values';

async function getRelatorioResumoVisitaFiliado(idVisitaFiliado) {
  try {
    const timeout = ServiceValues.timeout;
    const baseUrl = ServiceValues.base_url_local;
    const api = ServiceAxios(baseUrl, timeout);
    const dados = await api.get(
      `relatorio/resumo-registro-visita/${idVisitaFiliado}`,
      {
        responseType: 'blob'
      }
    );
    if (dados) {
      if (dados.data) {
        return {
          isSuccess: true,
          message: 'Relatório gerado com sucesso',
          result: dados.data
        };
      } else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        };
      }
    } else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }
  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };
  }
}

async function getRelatorioListagemFiliados(filtros) {
  try {
    const timeout = ServiceValues.timeout;
    const baseUrl = ServiceValues.base_url_local;
    const api = ServiceAxios(baseUrl, timeout);
    let params = {
      idFiliacaoStatus: filtros.idFiliacaoStatus
    };
    const dados = await api.get(`relatorio/relatorio-listagem-filiados/`, {
      responseType: 'blob',
      params: params
    });
    if (dados) {
      if (dados.data) {
        return {
          isSuccess: true,
          message: 'Relatório gerado com sucesso',
          result: dados.data
        };
      } else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        };
      }
    } else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }
  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };
  }
}

async function getRelatorioListagemVisitas(idFiliado, dataInicial, dataFinal) {
  try {
    const timeout = ServiceValues.timeout;
    const baseUrl = ServiceValues.base_url_local;
    const api = ServiceAxios(baseUrl, timeout);
    let params = {};
    if (dataInicial && dataFinal) {
      params.dataInicial = dataInicial;
      params.dataFinal = dataFinal;
    }
    if (idFiliado) {
      params.idFiliado = idFiliado;
    }
    const dados = await api.get(`relatorio/relatorio-listagem-visitas`, {
      responseType: 'blob',
      params: params
    });
    if (dados) {
      if (dados.data) {
        return {
          isSuccess: true,
          message: 'Relatório gerado com sucesso',
          result: dados.data
        };
      } else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        };
      }
    } else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }
  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };
  }
}

async function getRelatorioListagemVisitasGeral(dataInicial, dataFinal) {
  try {
    const timeout = ServiceValues.timeout;
    const baseUrl = ServiceValues.base_url_local;
    const api = ServiceAxios(baseUrl, timeout);
    let params = {};
    if (dataInicial && dataFinal) {
      params.dataInicial = dataInicial;
      params.dataFinal = dataFinal;
    }
    const dados = await api.get(`relatorio/relatorio-listagem-visitas-geral`, {
      responseType: 'blob',
      params: params
    });
    if (dados) {
      if (dados.data) {
        return {
          isSuccess: true,
          message: 'Relatório gerado com sucesso',
          result: dados.data
        };
      } else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        };
      }
    } else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }
  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };
  }
}

export {
  getRelatorioResumoVisitaFiliado,
  getRelatorioListagemFiliados,
  getRelatorioListagemVisitas,
  getRelatorioListagemVisitasGeral
};
